const SITE_MENU = [
    {title: "Home", url: "/"},
    {title: "Litepaper", url: "https://moonfit.xyz/litepaper", external: true},
    {title: "Whitepaper", url: "https://whitepaper.moonfit.xyz", external: true},
    {title: "Shop", url: "/", comingSoon: true}
]

export default SITE_MENU
